/**
 * AdminPresenter
 * --
 */
import React, { useState, useEffect } from 'react';
import { Content, Row, Col, Title, Tabs } from 'components';
import { Button, Input, Checkbox } from 'antd';
import { isMobile } from 'utils';

const defaultAccount = window.localStorage.getItem('jmadmin_account');
const jmadmin_account_flag = window.localStorage.getItem(
  'jmadmin_account_flag'
);

const AdminPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const {
    accountRef,
    passwordRef,
    tabKey,
    onSubmit,
    onSelect,
    onChange,
    inputValue,
  } = props;

  /* ===== STATE ===== */
  const [saveId, setSaveId] = useState(jmadmin_account_flag ? true : false);
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={0}>
      <Row>
        {!isMobile() && (
          <Col x={12}>
            <div
              className="bg-gradient"
              style={{ width: '100%', position: 'absolute', height: '100%' }}
            >
              <Content
                maxWidth={'100%'}
                padding={0}
                minHeight={'100vh'}
                // className="bg-gradient"
                backgroundColor="none"
                // backgroundColor="#2E75DF"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Title size={1} color="#FFFFFF">
                  {/* JM COFFEE */}
                  <img
                    src="/static/media/logo_w.e9cd5033688d4a828622df2ab1a8420d.svg"
                    alt=""
                  />
                  &nbsp; ADMIN
                </Title>
              </Content>
            </div>
          </Col>
        )}
        <Col x={isMobile() ? 24 : 12}>
          <Content
            maxWidth={'100%'}
            padding={0}
            minHeight={'100vh'}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: isMobile() ? 24 : 0,
            }}
          >
            <div style={{ width: 600 }}>
              <div style={{ marginBottom: 30 }}>
                <Tabs
                  items={[
                    { label: '관리자', key: 'ADMIN' },
                    { label: '쇼핑몰 관리자', key: 'SHOP_ADMIN' },
                    { label: '매장 관리자', key: 'STORE_ADMIN' },
                  ]}
                  activeKey={tabKey}
                  onChange={(e) => onSelect(e)}
                  style={{ fontSize: 18 }}
                />
              </div>
              <Title style={{ marginBottom: 10 }}>
                {tabKey === 'SHOP_ADMIN'
                  ? '쇼핑몰'
                  : tabKey === 'STORE_ADMIN'
                  ? '매장'
                  : ''}{' '}
                관리자 로그인
              </Title>

              <div>
                <div style={{ marginBottom: 10 }}>
                  <Input
                    ref={accountRef}
                    size="large"
                    placeholder="아이디"
                    name="account"
                    defaultValue={
                      jmadmin_account_flag === 'true' ? defaultAccount : ''
                    }
                    value={inputValue.account}
                    onChange={(e) => onChange('account', e.target.value)}
                    onPressEnter={() => onSubmit(saveId)}
                  />
                </div>
                <div style={{ marginBottom: 10 }}>
                  <Input.Password
                    ref={passwordRef}
                    size="large"
                    placeholder="비밀번호"
                    name="password"
                    value={inputValue.password}
                    onChange={(e) => onChange('password', e.target.value)}
                    onPressEnter={() => onSubmit(saveId)}
                  />
                </div>
                <div>
                  <Checkbox
                    checked={saveId}
                    onChange={(e) => setSaveId(e.target.checked)}
                  >
                    아이디 저장
                  </Checkbox>
                </div>
                <br />
                <div style={{ marginBottom: 10 }}>
                  <Button
                    size="large"
                    type="primary"
                    style={{
                      width: '100%',
                      // background: 'var(--primary-color)',
                      background: '#3b88f9',
                      boxShadow: 'none',
                    }}
                    onClick={() => onSubmit()}
                  >
                    로그인
                  </Button>
                </div>
              </div>
            </div>
          </Content>
        </Col>
      </Row>
    </Content>
  );
};

export default AdminPresenter;
